import React from 'react';

// eslint-disable-next-line react/prop-types
const ConfirmationCode = ({ code, className }) => (
  <div className={`u-flex u-justify-content-space-between u-align-center ${className || ''}`}>
    <span className="u-text-normal u-co-grey u-mr-6">Confirmation code</span>
    <span className="c-badge">{code}</span>
  </div>
);

export default ConfirmationCode;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerCanceledAppointment/components/ConfirmationCode.jsx